import React from "react";
import ErrorPage from "pages/ErrorPage/ErrorPage";
import useAppContext, { ACCOUNT_TYPES } from "state/AppContext";
import AdminTopNav from "components/navigations/AdminNavs/AdminTopNav";

export default function AdminLayerBlueprint(WrappedComponent) {
  return function AdminLayerComponent(props) {
    const appContext = useAppContext();
    const { account } = appContext;
    const { accountType } = account;

    if (accountType.type === ACCOUNT_TYPES.ADMIN.type) {
      return (
        <div className="bg-gray-50 min-h-screen max-h-screen">
          <AdminTopNav />
          <section className="relative top-[60px]">
            <WrappedComponent {...props} />
          </section>
        </div>
      );
    } else return <ErrorPage />;
  };
}
